import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PhysicalPrepaidCardIndexResponse } from '@/repositories/generated';

const content: PhysicalPrepaidCardIndexResponse[] = [
  {
    gift: undefined,
    giftDetail: undefined,
    paymentMethodId: '001',
    physicalPrepaidCardNumber: '0000000000000001',
    prepaidType: 'NORMAL',
    status: 'CREATE',
    totalBalance: 1000,
    walletService: {
      id: '001',
      name: 'モックWS001',
    },
  },
  {
    gift: {
      giftType: 'BENEFITS',
      id: 'gift002',
      name: '〇〇市給付金2',
    },
    giftDetail: {
      id: 'gift-detail001',
      name: '【赤券】（大型店・一般店で利用可能）',
    },
    paymentMethodId: '001',
    physicalPrepaidCardNumber: '0000000000000002',
    prepaidType: 'GIFT_CERTIFICATE',
    status: 'ACTIVE',
    totalBalance: 1000,
    walletService: {
      id: '001',
      name: 'モックWS001',
    },
  },
  {
    gift: {
      giftType: 'BENEFITS',
      id: 'gift001',
      name: '〇〇市プレミアム付商品券1',
    },
    giftDetail: {
      id: 'gift-detail001',
      name: '【赤券】（大型店・一般店で利用可能）',
    },
    paymentMethodId: '001',
    physicalPrepaidCardNumber: '0000000000000003',
    prepaidType: 'GIFT_CERTIFICATE',
    status: 'DISABLED',
    totalBalance: 1000,
    walletService: {
      id: '001',
      name: 'モックWS001',
    },
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const physicalPrepaidCard = http.get(
  createMockEndpoint('/physical_prepaid_card'),
  async () => {
    await delay(500);
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
